exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modulesidebar[data-v-183935e8]{grid-area:sidebar;font-size:14px;line-height:18px;font-weight:300}.modulesidebar__btn[data-v-183935e8]{margin-bottom:18px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-183935e8","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/modules/modulesidebar/ModuleSidebar.vue
// module id = e81697fd4ce7544e07d5
// module chunks = 0